// Navigation model for the admin shell: four primary tabs, and subnav groups
// that appear above a page when it belongs to one of them.

export type NavGroup = 'home' | 'songs' | 'roster' | 'setlists' | 'people' | 'billing' | 'account' | 'help' | 'none';

export const PRIMARY_TABS: Array<{ group: NavGroup; label: string; path: string }> = [
  { group: 'home', label: 'Home', path: '/admin/dashboard' },
  { group: 'songs', label: 'Songs', path: '/admin/songs' },
  { group: 'roster', label: 'Roster', path: '/admin/roster' },
  { group: 'setlists', label: 'Setlists', path: '/admin/setlists' },
];

const GROUP_BY_SEGMENT: Record<string, NavGroup> = {
  dashboard: 'home',
  songs: 'songs',
  'chord-library': 'songs',
  roster: 'roster',
  'team-availability': 'roster',
  setlists: 'setlists',
  team: 'people',
  members: 'people',
  invite: 'people',
  'membership-requests': 'people',
  subscription: 'billing',
  billing: 'billing',
  settings: 'account',
  profile: 'account',
  'developer-settings': 'account',
  tips: 'help',
  support: 'help',
  notifications: 'none',
};

export const groupForPath = (pathname: string): NavGroup => {
  const seg = pathname.replace(/^\/admin\/?/, '').split('/')[0];
  return GROUP_BY_SEGMENT[seg] ?? 'home';
};

export interface SubnavItem {
  path: string;
  label: string;
  /** Badge source, resolved by the shell. */
  badge?: 'requests';
  /** Visibility gate, resolved by the shell. */
  gate?: 'chordAi' | 'apiKeys';
}

export const SUBNAV: Partial<Record<NavGroup, SubnavItem[]>> = {
  songs: [
    { path: '/admin/songs', label: 'Library' },
    { path: '/admin/chord-library', label: 'Song Studio', gate: 'chordAi' },
  ],
  roster: [
    { path: '/admin/roster', label: 'Roster' },
    { path: '/admin/team-availability', label: 'Availability' },
  ],
  people: [
    { path: '/admin/team', label: 'Teams' },
    { path: '/admin/members', label: 'Members' },
    { path: '/admin/invite', label: 'Invite codes' },
    { path: '/admin/membership-requests', label: 'Requests', badge: 'requests' },
  ],
  billing: [
    { path: '/admin/subscription', label: 'Plan' },
    { path: '/admin/billing', label: 'Billing' },
  ],
  account: [
    { path: '/admin/settings', label: 'Church settings' },
    { path: '/admin/profile', label: 'Profile' },
    { path: '/admin/developer-settings', label: 'Developer', gate: 'apiKeys' },
  ],
  help: [
    { path: '/admin/tips', label: 'Tips' },
    { path: '/admin/support', label: 'Support' },
  ],
};
